import { render, staticRenderFns } from "./ProfileMisPedidos.vue?vue&type=template&id=bf615f42&"
import script from "./ProfileMisPedidos.vue?vue&type=script&lang=js&"
export * from "./ProfileMisPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports